export default "__VITE_ASSET__2434674a__$_?component__"